import React from "react";
import {isEmpty} from "es-toolkit/compat";
import Icon from "@/components/Global/Icon/Icon";
import RenderIf from "@/components/Global/RenderIf/RenderIf";

import {version} from "../../../../package.json";

import {config} from "@/config";
import styles from "./InitialContainer.module.scss";

export default function InitialContainer({
  children,
  className = "",
  isTitleBig = false,
  title,
  subtitle,
  logoOverride,
  showVersion = true,
  showLogo = true,
  style = {},
}) {
  const {websiteId} = config;
  return (
    <div className={styles.initialContainer}>
      <div className={`${styles.wrapper} ${className}`} {...(!isEmpty(style) && {style})}>
        <div className={styles.content}>
          <RenderIf isTrue={showLogo}>
            <RenderIf isTrue={logoOverride != ""}>
              <img src={logoOverride} className={styles.logoOverride} />
            </RenderIf>
            <RenderIf isTrue={websiteId == 1 && logoOverride == ""}>
              <Icon icon={"forth-icon-gradient"} className={styles.iconGradient} />
            </RenderIf>
          </RenderIf>
          <RenderIf isTrue={subtitle}>
            <h4 className="text-uppercase mt-4 mb-2">{subtitle}</h4>
          </RenderIf>
          <RenderIf isTrue={title}>
            <h1 className={`mt-1 ${isTitleBig ? styles.titleBig : ""}`}>{title}</h1>
          </RenderIf>
          {children}
        </div>
        <div className={"d-flex flex-column justify-content-center align-items-center"}>
          <RenderIf isTrue={showLogo}>
            {/* <RenderIf isTrue={logoOverride != ""}>
            <img src={logoOverride} className={styles.logoOverride} />
          </RenderIf> */}
            <RenderIf isTrue={websiteId == 1 && (!logoOverride || logoOverride == "")}>
              <Icon icon="text-logo" className={styles.logoName} />
            </RenderIf>
          </RenderIf>
          <RenderIf isTrue={websiteId == 2 && (!logoOverride || logoOverride == "")}>
            <Icon icon={"edge-icon-gradient"} className={styles.edgeIcon} />
          </RenderIf>
          <RenderIf isTrue={showVersion}>
            <div className={styles.appVersion}>APP VERSION {version}</div>
          </RenderIf>
        </div>
      </div>
    </div>
  );
}
